import React, { useState, useEffect } from 'react';
import './App.css';
// import Monster from './Page/Monster';
// import Login from './Page/Login';
// import GuildMember from './Page/GuildMember';
// import ProfileModal from './Page/ProfileModal';
// import UpLoadCounter from './Page/UploadCounter';
// import PostList from './Page/PostList';
// import MonsterSelect from './Page/MonsterSelect';
// import CounterList from './Page/CounterList';
import PostListDesktop from './Page/Desktop/PostList';
import PostListMobile from './Page/Mobile/PostList';
import MonsterSelect from './Page/Desktop/MonsterSelect';
import { Post } from './types/Post';
import CounterListDesktop from './Page/Desktop/CounterList';
import CounterListMobile from './Page/Mobile/CounterList';
import UploadCounterDesktop from './Page/Desktop/UploadCounter';
import UploadCounterMobile from './Page/Mobile/UploadCounter';
import GuildMemberDesktop from './Page/Desktop/GuildMember';
import GuildMemberMobile from './Page/Mobile/GuildMember';
import MonsterDesktop from './Page/Desktop/Monster';
import MonsterMobile from './Page/Mobile/Monster';
import PageContainer from './Page/PageContainer';
import { imageCache } from './utils/imageCache';


function App() {
  useEffect(() => {
    // 이미지 캐시 정리 (1시간마다)
    const cleanupInterval = setInterval(() => {
      imageCache.cleanupOldCache();
    }, 60 * 60 * 1000); // 1시간

    // 페이지 언로드 시 캐시 정리
    const handleBeforeUnload = () => {
      imageCache.cleanupOldCache(30 * 60 * 1000); // 30분 이상된 것만 정리
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      clearInterval(cleanupInterval);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return <PageContainer />;
}

export default App;
